export default {"src":"/_next/static/media/aadhaar_link.2fa8f9f8.svg","height":350,"width":350,"blurWidth":0,"blurHeight":0};